import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, map } from 'lodash';
import { Link } from 'react-router';
import { Col, Row } from 'react-bootstrap';
import { InfoLabel } from '../../../../common/components/index';

const PolicyHistory = ({ quotesHistory, status }) => {
  if (status !== 'quote') {
    return null;
  }
  return (
    <div>
      <Row>
        <Col sm={12} className="section-title">
          <h3>History</h3>
        </Col>
        <Col sm={12}>
          {!isEmpty(quotesHistory) && (
            <div>
              <div>
                <div className="form-horizontal" style={{ paddingLeft: '2px' }}>
                  <InfoLabel
                    labelSize={2}
                    label="Versions"
                    value={map(quotesHistory, (quotes, index) => {
                      return (
                        <Link
                          key={index}
                          to={`/policies/applications/${quotes.id}`}
                          style={{ paddingRight: '10px' }}
                        >
                          {`${quotes.attributes.quote_reference}/${
                            quotes.attributes.version
                          }`}
                        </Link>
                      );
                    })}
                  />
                </div>
              </div>
            </div>
          )}
        </Col>
      </Row>
      <div className="hr" />
    </div>
  );
};

PolicyHistory.propTypes = {
  quotesHistory: PropTypes.array.isRequired,
};

export default PolicyHistory;
